import { isEmpty } from '@sigma-frontend-libs/commons'
import { EScheduleFrequency, EWeekDays } from '@sigmasms/shared-types'

import { serviceNameViaPoint } from '@/components/services/report-manager/recurrent/utils'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    /**
     * Проверяет, есть ли в карточке хотя бы одно реально заполненное поле filterBy.
     *
     * @returns {boolean}
     */
    hasFilterBy() {
      return Object.values(this.value?.filterBy || {}).some(value => {
        if (Array.isArray(value)) {
          return Boolean(value.length)
        }

        return !isEmpty(value)
      })
    },

    /**
     * Возвращает подпись периодичности для карточки повторяющегося отчёта.
     *
     * @returns {{ value: string, label: string } | undefined}
     */
    frequency() {
      const frequencyText = this.getTranslate(`${serviceNameViaPoint}.frequencies.${this.value.scheduleFrequency}`)
      const specificWeekDay = this.value.specificWeekDay
      let weekDayText = this.getTranslate(`${serviceNameViaPoint}.weekDays.${EWeekDays.SUNDAY}`)

      if (specificWeekDay) {
        weekDayText = this.getTranslate(`${serviceNameViaPoint}.weekDays.${this.value.specificWeekDay}`)
      }

      switch (this.value.scheduleFrequency) {
        case EScheduleFrequency.EVERY_MONTH: return {
          value: frequencyText,
          label: this.getTranslate(`${serviceNameViaPoint}.titles.frequency`)
        }
        case EScheduleFrequency.EVERY_WEEK: return {
          value: frequencyText,
          label: weekDayText
        }
      }
    }
  },

  render
}
